import React from "react";
import { useParams } from "react-router-dom";
import CitySectorLanding from "./CitySectorLanding";
import AmountLanding from "./AmountLanding";
import { AMOUNT_BUCKETS } from "@/data/seoContent";

/**
 * Dispatcher for /business-loans/:slug — routes to amount page if the slug
 * matches one of our amount buckets (50k, 500k, 5m etc.), otherwise treats it
 * as a UK city slug (london, manchester, birmingham …).
 */
export default function BusinessLoansRoute() {
  const { slug } = useParams();
  const isAmount = AMOUNT_BUCKETS.some((b) => b.slug === slug);
  return isAmount ? <AmountLanding /> : <CitySectorLanding kind="city" />;
}
